import React from 'react';
import './scroll.scss';

const Scroll = () => <div className={'main-scroll'}></div>;

export default Scroll;
